import * as React from 'react'

import Flex from '../../primitives/Flex'
import Icon, { Icons } from '../../primitives/Icon'
import Text, { TextProps } from '../../primitives/Text'

interface Props extends Pick<TextProps, 'size'> {
  alternativeColor?: boolean
}

const AdvantageWrapper: React.FC<React.PropsWithChildren<Props>> = ({ children, alternativeColor, size }) => (
  <Flex alignItems="center" horizontalSpacing="default">
    <Icon icon={Icons.SUCCESS} color={alternativeColor ? 'white' : 'primary.main'} size="large" />
    <Text color={alternativeColor ? 'alternativeText' : 'text.primary'} size={size}>
      {children}
    </Text>
  </Flex>
)

export default AdvantageWrapper
